import { render, staticRenderFns } from "./BoxSentimentAnalysis.vue?vue&type=template&id=0f3a15f5&scoped=true&"
import script from "./BoxSentimentAnalysis.vue?vue&type=script&lang=js&"
export * from "./BoxSentimentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BoxSentimentAnalysis.vue?vue&type=style&index=0&id=0f3a15f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a15f5",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtnToggle,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtnToggle,QIcon})
